<template>
  <div id="app">
    <MobileHeader v-if="!isAdminPage" />
    <TopBanner v-if="!isAdminPage" @open-register="openFloatingRegister" />
    <main class="main-content" :class="{ 'with-header': !isAdminPage, 'admin-full': isAdminPage }">
      <router-view />
    </main>
    <FooterSection v-if="!isAdminPage" />
    <MobileFloatingBar v-if="!isAdminPage" ref="floatingBar" />
  </div>
</template>

<script>
import TopBanner from '@/components/TopBanner.vue'
import MobileFloatingBar from '@/components/MobileFloatingBar.vue'
import MobileHeader from '@/components/MobileHeader.vue'
import FooterSection from '@/components/FooterSection.vue'

export default {
  name: 'App',
  components: { TopBanner, MobileFloatingBar, MobileHeader, FooterSection },
  computed: {
    isAdminPage() {
      return this.$route.path.startsWith('/admin')
    }
  },
  methods: {
    openFloatingRegister() {
      if (this.$refs.floatingBar) {
        this.$refs.floatingBar.openRegister()
      }
    }
  }
}
</script>

<style>
@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable-dynamic-subset.min.css');
@import url('https://cdn.jsdelivr.net/gh/webfontworld/score/SCoreDream.css');

:root {
  /* Typography — 둥근 친근한 톤 */
  --font-sans: 'Pretendard Variable', 'Pretendard', -apple-system, sans-serif;
  --font-rounded: 'S-Core Dream', 'Pretendard Variable', 'Pretendard', sans-serif;
  --font-pretendard: var(--font-sans);

  /* Legacy aliases — 모두 둥근 산세리프로 통합 */
  --font-serif-kr: var(--font-rounded);
  --font-serif-en: var(--font-rounded);
  --font-display: var(--font-rounded);
  --font-mono-disp: var(--font-sans);

  /* 천안 휴먼빌 퍼스트시티 — Brand Palette */
  --le-noir: #0B0B0F;
  --le-ink: #16161C;
  --le-charcoal: #2A2A33;
  --le-graphite: #4A4751;
  --le-warm-grey: #807A73;
  --le-pearl: #F4EFE6;
  --le-bone: #EFE8DA;
  --le-cream: #FAF7F0;
  --le-white: #FFFFFF;

  /* Brand accent — Logo Blue #142d85 (텍스트 / 라인 / 강조) */
  --le-champagne: #142d85;
  --le-champagne-light: #2a45a5;
  --le-champagne-dark: #142d85;
  --le-gold-line: rgba(20, 45, 133, 0.32);
  --le-gold-line-soft: rgba(20, 45, 133, 0.16);

  /* Brand accent (alias) */
  --le-orange: #142d85;
  --le-orange-light: #2a45a5;
  --le-orange-dark: #142d85;

  /* Legacy mapping for existing components */
  --primary: var(--le-noir);
  --primary-light: var(--le-ink);
  --primary-dark: #000000;
  --sub-color: var(--le-pearl);
  --text-color: #3A3A3A;
  --white: #ffffff;
  --font-family: var(--font-sans);
  --font-family2: var(--font-serif-en);
  --font-family4: var(--font-serif-kr);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root { --page-max: 1040px; --page-bg: #E6E1D8; }

#app {
  font-family: var(--font-sans);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--le-ink);
  background: var(--page-bg);
}

html, body {
  overflow-x: hidden;
  width: 100%;
  background: var(--page-bg);
}

/* ===== PC 프레임: 풀스크린 대신 중앙 고정폭 ===== */
.main-content,
.site-footer {
  max-width: var(--page-max);
  margin-left: auto;
  margin-right: auto;
}
.main-content { background: #ffffff; }
/* 어드민은 풀폭 사용 */
.main-content.admin-full { max-width: none; margin-left: 0; margin-right: 0; }
.mobile-header,
.top-banner,
.mobile-floating-bar {
  max-width: var(--page-max);
  margin-left: auto;
  margin-right: auto;
}

img { display: block; max-width: 100%; }

.main-content.with-header {
  padding-top: 60px;
}

body.has-top-banner .main-content.with-header {
  padding-top: 120px;
}

#app {
  overflow-x: hidden;
  width: 100%;
}
</style>
